import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth }      from './context/AuthContext';
import { EquipoProvider }             from './context/EquipoContext';
import { ArbitroProvider }            from './context/ArbitroContext';
import { TercerTiempoProvider }       from './context/TercerTiempoContext';
import Layout                         from './components/layout/Layout';
import Landing                        from './pages/Landing';
import Login                          from './pages/Login';
import Registro                       from './pages/Registro';
import AuthCallback                   from './pages/AuthCallback';
import RegistroRecinto                from './pages/registro/RegistroRecinto';
import RegistroArbitro                from './pages/registro/RegistroArbitro';
import RegistroTercerTiempo           from './pages/registro/RegistroTercerTiempo';
import Dashboard                      from './pages/Dashboard';
import Matchmaking                    from './pages/Matchmaking';
import Desafios                       from './pages/Desafios';
import Partidos                       from './pages/Partidos';
import PostPartido                    from './pages/PostPartido';
import Ranking                        from './pages/Ranking';
import PerfilPublico                  from './pages/PerfilPublico';
import Recintos                       from './pages/Recintos';
import Arbitros                       from './pages/Arbitros';
import TercerTiempo                   from './pages/TercerTiempo';
import Nomina                         from './pages/Nomina';
import Estadisticas                   from './pages/Estadisticas';
import PanelRecinto                   from './pages/PanelRecinto';
import CrearEquipo                    from './pages/CrearEquipo';
import PanelProveedor                 from './pages/PanelProveedor';
import AdminPanel                     from './pages/AdminPanel';
import PaginaInvitacion               from './pages/PaginaInvitacion';
import PaginaUnete                    from './pages/PaginaUnete';
import { usePush }                      from './hooks/usePush';

function RutaProtegida({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  usePush(user);
  return (
    <Routes>
      <Route path="/"                       element={<Landing />} />
      <Route path="/login"                  element={<Login />} />
      <Route path="/registro"               element={<Registro />} />
      <Route path="/auth/callback"          element={<AuthCallback />} />
      <Route path="/registro-recinto"       element={<RegistroRecinto />} />
      <Route path="/registro-arbitro"       element={<RegistroArbitro />} />
      <Route path="/registro-tercer-tiempo" element={<RegistroTercerTiempo />} />
      <Route path="/equipo/:slug"           element={<PerfilPublico />} />
      <Route path="/invitacion/:token"      element={<PaginaInvitacion />} />
      <Route path="/unete/:deporte/:token"  element={<PaginaUnete />} />

      {/* Panel proveedor — sin Layout */}
      <Route path="/app/panel-proveedor" element={
        <RutaProtegida><PanelProveedor /></RutaProtegida>
      } />

      {/* Panel recinto — sin Layout */}
      <Route path="/app/panel-recinto" element={
        <RutaProtegida><PanelRecinto /></RutaProtegida>
      } />

      {/* Panel admin — sin Layout */}
      <Route path="/admin" element={
        <RutaProtegida><AdminPanel /></RutaProtegida>
      } />

      {/* Rutas protegidas con Layout */}
      <Route path="/app" element={
        <RutaProtegida><Layout /></RutaProtegida>
      }>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard"      element={<Dashboard />} />
        <Route path="matchmaking"    element={<Matchmaking />} />
        <Route path="desafios"       element={<Desafios />} />
        <Route path="partidos"       element={<Partidos />} />
        <Route path="post-partido"   element={<PostPartido />} />
        <Route path="ranking"        element={<Ranking />} />
        <Route path="recintos"       element={<Recintos />} />
        <Route path="arbitros"       element={<Arbitros />} />
        <Route path="tercer-tiempo"  element={<TercerTiempo />} />
        <Route path="nomina"         element={<Nomina />} />
        <Route path="estadisticas"   element={<Estadisticas />} />
        <Route path="crear-equipo"   element={<CrearEquipo />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <EquipoProvider>
          <ArbitroProvider>
            <TercerTiempoProvider>
              <AppRoutes />
            </TercerTiempoProvider>
          </ArbitroProvider>
        </EquipoProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
